var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Facebook = function (_a) {
    var color = _a.color, background = _a.background, props = __rest(_a, ["color", "background"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40" }, props),
        React.createElement("g", { fill: "none" },
            React.createElement("circle", { cx: "20", cy: "20", r: "20", fill: background, className: "ic_background" }),
            React.createElement("path", { fill: color, className: "ic_filling", d: "M24.43 7.813c2.188 0 4.476.39 4.476.39v4.922h-2.522c-2.484 0-3.26 1.541-3.26 3.123V20h5.548l-.887 5.782h-4.66v13.975a20.15 20.15 0 0 1-6.25 0V25.781h-5.078V20h5.078v-4.406c0-5.012 2.986-7.781 7.555-7.781z" }))));
};
Facebook.defaultProps = {
    background: '#555',
    color: '#151515',
};
export default Facebook;
//# sourceMappingURL=Facebook.js.map